module.exports = __webpack_public_path__ + "static/media/pin-controls-selected.05b0dfb2.svg";